module.exports = __webpack_public_path__ + "static/award10-ec98011e5312ae55b755cd102808ca12.png";